import { I18n } from 'emoji-mart';
import { defineMessages, IntlShape } from 'react-intl';

import { keys } from '../utils/keys';

const msgs = defineMessages({
	search: { id: 'emoji.search', defaultMessage: 'Поиск' },
	notfound: { id: 'emoji.notFound', defaultMessage: 'Эмодзи не найдено' },
	categorieslabel: { id: 'emoji.categorieslabel', defaultMessage: 'Категории' },
	'categories.search': { id: 'emoji.categories.search', defaultMessage: 'Результаты поиска' },
	'categories.recent': { id: 'emoji.categories.recent', defaultMessage: 'Часто используемые' },
	'categories.smileys': { id: 'emoji.categories.smileys', defaultMessage: 'Смайлики и эмоции' },
	'categories.people': { id: 'emoji.categories.people', defaultMessage: 'Люди' },
	'categories.nature': { id: 'emoji.categories.nature', defaultMessage: 'Животные и природа' },
	'categories.foods': { id: 'emoji.categories.foods', defaultMessage: 'Еда' },
	'categories.activity': { id: 'emoji.categories.activity', defaultMessage: 'Увлечения' },
	'categories.places': { id: 'emoji.categories.places', defaultMessage: 'Путешествия' },
	'categories.objects': { id: 'emoji.categories.objects', defaultMessage: 'Объекты' },
	'categories.symbols': { id: 'emoji.categories.symbols', defaultMessage: 'Знаки' },
	'categories.flags': { id: 'emoji.categories.flags', defaultMessage: 'Флаги' },
});

export const EMOJI_I18N = ({ formatMessage }: IntlShape): I18n => {
	return keys(msgs).reduce((acc, v) => {
		if (v.includes('.')) {
			const [objName, key] = v.split('.') as ['categories', keyof I18n['categories']];
			if (!acc[objName]) {
				acc[objName] = {} as I18n['categories'];
			}
			acc[objName][key] = formatMessage(msgs[v]);

			return acc;
		}

		acc[v as Exclude<keyof I18n, 'categories'>] = formatMessage(msgs[v]);

		return acc;
	}, {} as I18n);
};
